module.exports = __webpack_public_path__ + "static/media/inf_haz_lev.7034bcd9.png";